import { Modal } from '@praktio/common-ui';
import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { resetCourseProgress } from '../../../../ducks/users';
import { resetTeamCourseProgress } from '../../../../ducks/teams';

// TODO: Figure out how to do "either one param or other, but not both"
// because this component needs either a teamId or userId, but not both.
// It might be easier to just have separate components for each case?
interface IProps {
  email?: string;
  userId?: string;
  courseId?: string;
  teamId?: string;
  onHide: () => void;
  show: boolean;
  setShowOverlay: (show: boolean) => void;
  all?: boolean;
}

const ResetProgressModal: FC<IProps> = ({
  email,
  onHide,
  show,
  userId,
  teamId,
  courseId,
  setShowOverlay,
  all,
}) => {
  const dispatch = useDispatch();
  if (!teamId && !userId) {
    return null;
  }

  let description =
    'Are you sure you want to reset ALL team course progress for users of this team?';

  if (userId) {
    description = `Are you sure you want to reset ${
      all ? 'ALL ' : ''
    }progress for the user "${email}"?`;
  }

  const title = `Reset ${teamId ? 'Team' : 'User'} Progress`;
  return (
    <Modal
      onHide={onHide}
      onSave={async () => {
        setShowOverlay(true);
        if (teamId) {
          await dispatch(resetTeamCourseProgress({ teamId }));
        } else if (userId) {
          if (all) {
            await dispatch(resetCourseProgress({ userId, all: true }));
          } else if (courseId) {
            await dispatch(resetCourseProgress({ userId, courseId }));
          }
        }
        setShowOverlay(false);
      }}
      show={show}
      confirmationString="RESET"
      title={title}
      description={description}
    />
  );
};

export default ResetProgressModal;
